import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Link, Row, Typography } from '@tempmee/react';
import { OutlineExternalLinkIcon } from '@tempmee/react-icons';
import { brandPrimary, colors } from '@tempmee/tailwind';

interface IHelpMenuLinkBaseProps {
  text: string;
  onClick?: () => void;
}

type TInternalHelpMenuLinkProps = IHelpMenuLinkBaseProps & {
  to: string;
  externalHref?: never;
};

type TExternalHelpMenuLinkProps = IHelpMenuLinkBaseProps & {
  externalHref: string;
  to?: never;
};

type THelpMenuLinkProps = TInternalHelpMenuLinkProps | TExternalHelpMenuLinkProps;

export const HelpMenuLink = (props: THelpMenuLinkProps) => {
  const { text, onClick } = props;
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const label = (
    <Typography
      as="span"
      color={isHovered ? colors.neutral[300] : colors.neutral[600]}
      variant="body1"
      bold
    >
      {text}
    </Typography>
  );

  if (props.externalHref !== undefined) {
    return (
      <Link
        href={props.externalHref}
        target="_blank"
        rel="noopener noreferrer"
        color="inherit"
        underline="none"
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Row align="center" gap={2}>
          {label}
          <OutlineExternalLinkIcon color={brandPrimary[500]} />
        </Row>
      </Link>
    );
  }

  const handleClick = () => {
    onClick?.();
    navigate(props.to);
  };

  return (
    <button
      type="button"
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        width: 'fit-content',
      }}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {label}
    </button>
  );
};
